import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(6),
      paddingRight: 0,
      paddingLeft: 0,
      minHeight: 'calc(100vh - 48px)',
      fontFamily: 'Roboto !important'
    },
    containerCovered: {
      paddingLeft: '51px'
    },
    content: {
      padding: theme.spacing(3)
    },
    noPadding: {
      padding: 0,
      minHeight: 'calc(100vh - 48px)'
    },
    columnHeader: {
      marginBottom: theme.spacing(2)
    },
    multiColumns: {
      display: 'flex',
      alignItems: 'stretch',
      minHeight: 'calc(100vh - 48px)',
      flexWrap: 'wrap-reverse'
    },
    leftColumn: {
      borderRight: '1px solid #e0e0e0',
      flexGrow: 1,
      padding: theme.spacing(2)
    },
    centerColumn: {
      flexGrow: 4,
      padding: theme.spacing(2)
    },
    rightColumn: {
      flexGrow: 1
    }
  });
